export default {
      id: "folder-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#folder",
      toString: function () {
        return this.url;
      }
    }